'use strict';

var dataLayer = window.dataLayer || [];

/**
 * Get GTM data element by product id
 * @param {string} pid - ProductId
 * @returns {JQuery<HTMLElement>} - jQuery element containing GTM data for the given pid
 */
function getGtmDataByPid(pid) {
    var $gtmElements = window.jQuery('.gtm-data');

    var $matchedElement = $gtmElements.filter(function () {
        var gtmData = window.jQuery(this).data('gtm');
        return (
            (gtmData.item_variant && gtmData.item_variant === pid) || (gtmData.item_id && gtmData.item_id === pid)
        );
    });

    if ($matchedElement && $matchedElement.length) {
        return $matchedElement.first();
    }

    return $gtmElements.first();
}

module.exports = {
    tryItOn: function (clickedEvent) {
        var VirtualElement;

        var pidFromEvent = (clickedEvent && clickedEvent.data && clickedEvent.data.productCode) || (window.vtLastClicked && window.vtLastClicked.pid);
        var $gtmData = getGtmDataByPid(pidFromEvent);
        var data = $gtmData && $gtmData.data ? $gtmData.data('gtm') : null;
        var eventData = $gtmData && $gtmData.data ? $gtmData.data('event') : null;

        if (clickedEvent.data) {
            // 4. when user clicks on Capture Image:
            if (clickedEvent.event === 'UI-element-clicked' || clickedEvent.event === 'jewellery-selected' || clickedEvent.event === 'add-to-wishlist') {
                VirtualElement = clickedEvent.data.element ? clickedEvent.data.element : clickedEvent.event;
                if (VirtualElement === 'zoom-in') {
                    VirtualElement = 'Zoom in';
                } else if (VirtualElement === 'zoom-out') {
                    VirtualElement = 'Zoom out';
                }
                let obj = {
                    event: 'virtualTryOnData',
                    virtual_element: VirtualElement,
                    product_id: clickedEvent.data.productCode,
                    product_name: data.item_name,
                    lead_ID: eventData.customerNo,
                    user_name: eventData.fullName,
                    user_phone: eventData.phone,
                    event_date: eventData.currentDate
                };
                dataLayer.push(obj);
                localStorage.setItem('addToCartData', JSON.stringify({
                    product_id: clickedEvent.data.productCode,
                    product_name: data.item_name,
                    lead_ID: eventData.customerNo,
                    user_name: eventData.fullName,
                    user_phone: eventData.phone,
                    event_date: eventData.currentDate
                }));
            }

            // 2. when user closes the virtual try on pop up:
        } else if (clickedEvent.function === 'closeMirrar') {
            // no action needed for now
        }
    }
};
